export default {
  configDashboard: false,
  isProfileCard: false,
  isQueueCard: false,
  isQuestCard: false,
  isDevelopmentCharter: false,
  isWidgetCard: false,
  isTalentCard: false,
  isUserWallet:false,
  userWidgets: [],
  blinkers: JSON.parse(localStorage.getItem("dashboardBlinkers")) || {},
};
